// // AXIOS INTERCEPTORS ---------------------------------------------------

// // For Make Log on Develop Mode
// const logOnDev = (message: string, opts?: string) => {
//   if (import.meta.env.VITE_LOG_SERVICES === 'true') {
//     console.log(message, opts);
//   }
// };

// // Request Interceptor
// const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
//   const { method, url } = config;
//   // Set Headers Here
//   // Check Authentication Here
//   // Set Loading Start Here
//   logOnDev(`%c🚀 [API] ${method?.toUpperCase()} ${url} | Request`, 'color:cyan');

//   if (method === 'get') {
//     config.timeout = 15000;
//   }
//   return config;
// };

// const onResponse = (response: AxiosResponse): AxiosResponse => {
//   const { method, url } = response.config;
//   const { status } = response;
//   // Set Loading End Here
//   // Handle Response Data Here
//   // Error Handling When Return Success with Error Code Here
//   logOnDev(`%c🚀 [API] ${method?.toUpperCase()} ${url} | Response ${status}`, 'color:hsl(150, 80%, 60%)');

//   return response;
// };

// const onErrorResponse = (error: AxiosError | Error): Promise<AxiosError> => {
//   if (axios.isAxiosError(error)) {
//     const { message } = error;
//     const { method, url } = error.config as AxiosRequestConfig;
//     const { status, data } = (error.response as AxiosResponse) ?? {};

//     logOnDev(`%c🚨 [API] ${method?.toUpperCase()} ${url} | Error ${status} ${message}`, 'color:hsl(0%, 80%, 70%)');

//     // API Response Error
//     if (data?.errors) {
//       return Promise.reject(data.errors);
//     } else if (error.message === 'Network Error') {
//       return Promise.reject(new Error('Falha de conexão'));
//     }
//   } else {
//     logOnDev(`%c🚨 [API] | Error ${error.message}`, 'color:red');
//   }

//   return Promise.reject(new Error('Erro de sistema'));
// };

// const setupInterceptors = (instance: AxiosInstance): AxiosInstance => {
//   instance.interceptors.request.use(onRequest, onErrorResponse);
//   instance.interceptors.response.use(onResponse, onErrorResponse);

//   return instance;
// };

// // BASE CONNECTOR ---------------------------------------------------

// const instance = axios.create({
//   headers: { Authorization: 'Bearer TVVMVElURUNBUElTRVJWRVJBVVRI' },
//   baseURL: import.meta.env.VITE_BACKEND_URL,
// });

// setupInterceptors(instance);

import { AxiosResponse } from 'axios'

import { apiConn as instance } from '@/services/api/connector'

// prettier-ignore
const responseBody = <T>() => (response: AxiosResponse<{ result: T }>) => response.data.result;

// prettier-ignore
export const WitaConnector = {
    get:    <R = any>(url: string)            => instance.get    <{ result: R }>(url)       .then(responseBody<R>()),
    post:   <R = any>(url: string, body: any) => instance.post   <{ result: R }>(url, body) .then(responseBody<R>()),
    put:    <R = any>(url: string, body: any) => instance.put    <{ result: R }>(url, body) .then(responseBody<R>()),
    delete: <R = any>(url: string)            => instance.delete <{ result: R }>(url)       .then(responseBody<R>()),
};
